<template>
  <div class="overlay">
    <div class="call-flow-modal">
      <img src="@/assets/images/call_flow_modal.png" class="background-img" alt="background-img" />
      <div class="modal-content">
        <div class="modal-title">Here's how calls can be routed through &quot;{{ numberName }}&quot;</div>
        <div class="modal-buttons-row">
          <div class="button-container" @click="onRoute">
            Set up a call menu
            <img src="@/assets/images/call_flow_call_menu.png" class="button-img" alt="button-img" />
          </div>
          <div
            class="button-container"
            style="margin-left: 10px; color: #77A9D7; border-color: #77A9D7;"
            @click="onRoute"
          >
            Route to a person
            <img src="@/assets/images/call_flow_route_person.png" class="button-img" alt="button-img" />
          </div>
          <div
            v-if="withGroup"
            class="button-container"
            style="margin-left: 10px; color: #EC8145; border-color: #EC8145;"
            @click="onRoute"
          >
            Route to a group
            <img
              src="@/assets/images/call_flow_route_group.png"
              class="button-img"
              style="width: 64px;"
              alt="button-img"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallFlowModal',
  props: {
    numberName: String,
    withGroup: Boolean,
    onRoute: Function
  }
};
</script>

<style scoped lang="scss">
.call-flow-modal {
  position: relative;
  width: 850px;
  height: 480px;
  background-color: #ffffff;
  border-radius: 10px;

  .background-img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }

  .modal-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 50px;

    .modal-footer {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
      width: 100%;

      .modal-footer-next {
        cursor: pointer;
        font-weight: 500;
        font-size: 24px;
        line-height: 35px;
        color: white;
        background: #008619;
        border-radius: 8px;
        padding: 17px 80px;
      }
    }
  }

  .modal-title {
    margin-top: 100px;
    font-weight: 800;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    letter-spacing: -0.5px;
    color: $colorTitle;
  }

  .modal-buttons-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 50px;
    width: 100%;

    .button-container {
      flex: 1;
      height: 140px;
      background: #ffffff;
      border: 1px solid #819f77;
      box-shadow: 0px 4px 10px rgba(13, 29, 63, 0.05);
      border-radius: 4px;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      letter-spacing: -0.01em;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #819f77;
      cursor: pointer;

      .button-img {
        width: 42px;
        height: 42px;
        margin-top: 10px;
      }
    }
  }
}
</style>
